import { render, staticRenderFns } from "./ProcessoUtilizacaoListagem.vue?vue&type=template&id=749a06e4&scoped=true"
import script from "./ProcessoUtilizacaoListagem.vue?vue&type=script&lang=js"
export * from "./ProcessoUtilizacaoListagem.vue?vue&type=script&lang=js"
import style0 from "./ProcessoUtilizacaoListagem.vue?vue&type=style&index=0&id=749a06e4&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749a06e4",
  null
  
)

export default component.exports